import React, { useState } from 'react';
import placeholder from '../assets/placeholder.png';
import background from '../assets/Background_Test.jpg';

import gmAdamPearce from '../assets/gm/94400_ADAM_PEARCE.png';
import gmNickAldis from '../assets/gm/121300_NICK_ALDIS.png';
import gmShawnMichaels from '../assets/gm/45750_SHAWN_MICHAELS.png';
import gmAva from '../assets/gm/121400_AVA.png';
import gmStephanie from '../assets/gm/14700_STEPHANIE_MCMAHON.png';
import gmPaulHeyman from '../assets/gm/37410_PAUL_HEYMAN_14.png';
import gmWilliamRegal from '../assets/gm/94010_WILLIAM_REGAL.png';
import gmMickFoley from '../assets/gm/14400_MICK_FOLEY.png';
import gmTeddyLong from '../assets/gm/28600_TEDDY_LONG.png';
import gmEricBischoff from '../assets/gm/93900_ERIC_BISCHOFF.png';
import gmSherri from '../assets/gm/42850_SENSATIONAL_SHERRI.png';
import gmMissElizabeth from '../assets/gm/23450_MISS_ELIZABETH.png';
import gmMrFuji from '../assets/gm/130250_MR_FUJI.png';
import gmBobbyHeenan from '../assets/gm/24900_BOBBY_HENNAN.png';
import gmCMPunk from '../assets/gm/31250_CM_PUNK.png';
import gmXavierWoods from '../assets/gm/42030_XAVIER_WOODS.png';
import gmTylerBreeze from '../assets/gm/58110_TYLER_BREEZE.png';

import logoRaw from '../assets/brands/logos/RAW25_LOGO.png';
import logoSmackDown from '../assets/brands/logos/SMACKDOWN25_LOGO.png';
import logoNXT from '../assets/brands/logos/NXT_LOGO.png';
import logoNXT20 from '../assets/brands/logos/NXT20_LOGO.png';
import logoWCW from '../assets/brands/logos/WCW_LOGO.png';
import logoECW from '../assets/brands/logos/ECW_LOGO.png';
import logoNXTMutiny from '../assets/brands/logos/NXTMUTINY_LOGO.png';
import bgRaw from '../assets/brands/backgrounds/RAW25_BACKGROUND.png';
import bgSmackDown from '../assets/brands/backgrounds/SMACKDOWN25_BACKGROUND.png';
import bgNXT from '../assets/brands/backgrounds/NXT_BACKGROUND.png';
import bgNXT20 from '../assets/brands/backgrounds/NXT20_BACKGROUND.png';
import bgWCW from '../assets/brands/backgrounds/WCW_BACKGROUND.png';
import bgECW from '../assets/brands/backgrounds/ECW_BACKGROUND.png';
import bgNXTMutiny from '../assets/brands/backgrounds/NXTMUTINY_BACKGROUND.png';

const GM_RENDERS = {
  'Adam Pearce': gmAdamPearce, 'Nick Aldis': gmNickAldis, 'Shawn Michaels': gmShawnMichaels,
  'Ava': gmAva, 'Stephanie McMahon': gmStephanie, 'Paul Heyman': gmPaulHeyman,
  'William Regal': gmWilliamRegal, 'Mick Foley': gmMickFoley, 'Teddy Long': gmTeddyLong,
  'Eric Bischoff': gmEricBischoff, 'Sensational Sherri': gmSherri, 'Miss Elizabeth': gmMissElizabeth,
  'Mr Fuji': gmMrFuji, 'Bobby Heenan': gmBobbyHeenan, 'CM Punk': gmCMPunk,
  'Xavier Woods': gmXavierWoods, 'Tyler Breeze': gmTylerBreeze,
};

const BRAND_LOGOS = { 'Raw': logoRaw, 'SmackDown': logoSmackDown, 'NXT': logoNXT, 'NXT 2.0': logoNXT20, 'WCW': logoWCW, 'ECW': logoECW, 'NXT Mutiny': logoNXTMutiny };
const BRAND_BGS = { 'Raw': bgRaw, 'SmackDown': bgSmackDown, 'NXT': bgNXT, 'NXT 2.0': bgNXT20, 'WCW': bgWCW, 'ECW': bgECW, 'NXT Mutiny': bgNXTMutiny };
const BRAND_COLORS = { 'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#6c3483', 'NXT 2.0': '#148f77', 'WCW': '#b7950b', 'ECW': '#ba4a00', 'NXT Mutiny': '#2c3e50' };

const OFFICIAL_BRANDS = ['Raw', 'SmackDown', 'NXT', 'NXT 2.0', 'WCW', 'ECW', 'NXT Mutiny'];
const OFFICIAL_GMS = ['Adam Pearce', 'Nick Aldis', 'Shawn Michaels', 'Ava', 'Stephanie McMahon', 'Paul Heyman', 'William Regal', 'Mick Foley', 'Teddy Long', 'Eric Bischoff', 'Sensational Sherri', 'Miss Elizabeth', 'Mr Fuji', 'Bobby Heenan', 'CM Punk', 'Xavier Woods', 'Tyler Breeze', 'Stacy Keibler', 'Anonymous GM'];

const HOF_OPTIONS = [1, 10, 15, 20, 25, 30];

const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .tab-btn { transition: background 0.15s, border-color 0.15s, color 0.15s; cursor: pointer; }
  .tab-btn.active { border-bottom: 2px solid #fff !important; color: #fff !important; }
  .tab-btn:not(.active):hover { color: rgba(255,255,255,0.6) !important; }
  .option-btn { transition: background 0.15s, border-color 0.15s, color 0.15s; cursor: pointer; }
  .option-btn:hover { border-color: rgba(255,255,255,0.5) !important; color: #fff !important; }
  .option-btn.selected { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.7) !important; color: #fff !important; }
  .btn-wwe:hover { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.7) !important; color: #fff !important; }
  .rival-card:hover { border-color: rgba(255,255,255,0.3) !important; }
  .rival-card { transition: background 0.15s, border-color 0.15s; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }
  select option { background: #1a1a1a; color: #fff; }
`;

const S = {
  panel: { background: 'rgba(8,8,8,0.88)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: '10px', boxShadow: '0 20px 80px rgba(0,0,0,0.9)' },
  title: { fontFamily: "'Anton', sans-serif", letterSpacing: '3px', color: '#fff', textShadow: '0 0 28px rgba(180,0,0,0.5)' },
  btn: { fontFamily: "'Monda', sans-serif", letterSpacing: '1.5px', fontSize: '0.62rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.35)', color: 'rgba(255,255,255,0.8)', padding: '9px 28px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.18s, border-color 0.18s, color 0.18s' },
  mono: { fontFamily: "'Monda', sans-serif" },
  anton: { fontFamily: "'Anton', sans-serif" },
  label: { fontFamily: "'Monda', sans-serif", fontSize: '0.48rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px', display: 'block' },
  select: { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '4px', padding: '7px 12px', color: '#fff', fontSize: '0.6rem', fontFamily: "'Monda',sans-serif", outline: 'none', cursor: 'pointer' },
};

const OptionBtn = ({ label, selected, onClick, description }) => (
  <button className={`option-btn${selected ? ' selected' : ''}`}
    onClick={onClick}
    style={{ ...S.mono, fontSize: '0.58rem', background: selected ? 'rgba(255,255,255,0.1)' : 'transparent', border: `1px solid ${selected ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.2)'}`, color: selected ? '#fff' : 'rgba(255,255,255,0.45)', padding: description ? '10px 16px' : '8px 18px', borderRadius: '5px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', letterSpacing: '1px' }}>
    {label}
    {description && <span style={{ fontSize: '0.38rem', color: selected ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.25)', letterSpacing: '0.5px', fontWeight: 'normal' }}>{description}</span>}
  </button>
);

// ── Rival Card ──────────────────────────────────────────────────────
const RivalCard = ({ rival, index, onSet, onRemove }) => {
  const brandLogo = rival?.brand ? BRAND_LOGOS[rival.brand] : null;
  const brandColor = rival?.brand ? BRAND_COLORS[rival.brand] || '#d4af37' : 'rgba(255,255,255,0.15)';
  const brandBg = rival?.brand ? BRAND_BGS[rival.brand] : null;
  const gmRender = rival?.gm ? GM_RENDERS[rival.gm] : null;

  if (!rival) {
    return (
      <div className="rival-card"
        onClick={onSet}
        style={{ ...S.panel, flex: 1, minHeight: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px', cursor: 'pointer', border: '1px dashed rgba(255,255,255,0.12)', background: 'rgba(255,255,255,0.02)' }}>
        <div style={{ width: '40px', height: '40px', borderRadius: '50%', border: '1px dashed rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.2)', fontSize: '1.2rem' }}>+</div>
        <div style={{ ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '1px' }}>RIVAL {index + 1}</div>
      </div>
    );
  }

  return (
    <div className="rival-card"
      style={{ ...S.panel, flex: 1, overflow: 'hidden', position: 'relative', minHeight: '200px', display: 'flex', flexDirection: 'column', cursor: 'pointer', border: `1px solid ${brandColor}44` }}
      onClick={onSet}>
      {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(4px) brightness(0.3)', zIndex: 0 }} />}
      <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at bottom, ${brandColor}22 0%, transparent 70%)`, zIndex: 1 }} />

      {/* Remove button */}
      <button onClick={e => { e.stopPropagation(); onRemove(); }}
        style={{ position: 'absolute', top: '8px', right: '8px', zIndex: 4, background: 'rgba(0,0,0,0.6)', border: '1px solid rgba(231,76,60,0.4)', color: 'rgba(231,76,60,0.7)', borderRadius: '3px', padding: '2px 7px', fontSize: '0.5rem', cursor: 'pointer', fontFamily: "'Monda',sans-serif" }}>✕</button>

      {/* GM render */}
      <div style={{ position: 'relative', zIndex: 2, flex: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', overflow: 'hidden' }}>
        <img loading="lazy" src={gmRender || placeholder} alt={rival.gm}
          style={{ height: '130px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.9))', marginBottom: '-4px' }} />
      </div>

      {/* Info */}
      <div style={{ position: 'relative', zIndex: 2, padding: '8px 10px 10px', background: 'rgba(0,0,0,0.75)', borderTop: `1px solid ${brandColor}44`, textAlign: 'center' }}>
        {brandLogo && <img loading="lazy" src={brandLogo} alt={rival.brand} style={{ height: '22px', objectFit: 'contain', marginBottom: '4px', filter: 'drop-shadow(0 1px 4px rgba(0,0,0,0.9))' }} />}
        <div style={{ ...S.anton, fontSize: '0.52rem', letterSpacing: '1.5px', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{rival.gm?.toUpperCase()}</div>
        <div style={{ ...S.mono, fontSize: '0.38rem', color: 'rgba(255,255,255,0.35)', marginTop: '2px', letterSpacing: '1px' }}>CLICK TO EDIT</div>
      </div>
    </div>
  );
};

// ── Rival Picker Popup ──────────────────────────────────────────────
const RivalPicker = ({ rival, onClose, onSave }) => {
  const [brand, setBrand] = useState(rival?.brand || '');
  const [gm, setGm] = useState(rival?.gm || '');
  const brandColor = BRAND_COLORS[brand] || '#d4af37';
  const brandBg = BRAND_BGS[brand];
  const gmRender = GM_RENDERS[gm] || null;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(4px)' }}>
      <div style={{ ...S.panel, width: '100%', maxWidth: '480px', padding: '28px' }}>
        <div style={{ ...S.title, fontSize: '1rem', marginBottom: '20px' }}>SET RIVAL</div>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
          {/* Preview */}
          <div style={{ width: '130px', flexShrink: 0, borderRadius: '8px', overflow: 'hidden', border: `1px solid ${brandColor}44`, position: 'relative', height: '160px' }}>
            {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(4px) brightness(0.3)', zIndex: 0 }} />}
            <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at bottom, ${brandColor}22 0%, transparent 70%)`, zIndex: 1 }} />
            <div style={{ position: 'relative', zIndex: 2, height: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', overflow: 'hidden' }}>
              <img loading="lazy" src={gmRender || placeholder} alt={gm}
                style={{ height: '120px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.9))', marginBottom: '-4px' }} />
            </div>
          </div>

          {/* Selects */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div>
              <label style={S.label}>BRAND</label>
              <select style={{ ...S.select, width: '100%' }} value={brand} onChange={e => setBrand(e.target.value)}>
                <option value="">-- Choisir une brand --</option>
                {OFFICIAL_BRANDS.map(b => <option key={b} value={b}>{b}</option>)}
              </select>
            </div>
            <div>
              <label style={S.label}>GENERAL MANAGER</label>
              <select style={{ ...S.select, width: '100%' }} value={gm} onChange={e => setGm(e.target.value)}>
                <option value="">-- Choisir un GM --</option>
                {OFFICIAL_GMS.map(g => <option key={g} value={g}>{g}</option>)}
              </select>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button className="btn-wwe" style={S.btn} onClick={onClose}>CANCEL</button>
          <button className="btn-wwe"
            style={{ ...S.btn, borderColor: brand && gm ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.2)', color: brand && gm ? '#fff' : 'rgba(255,255,255,0.3)' }}
            onClick={() => { if (brand && gm) { onSave({ brand, gm }); onClose(); } }}>
            CONFIRM
          </button>
        </div>
      </div>
    </div>
  );
};

// ── MAIN ────────────────────────────────────────────────────────────
export default function GameSettings({ brand, gm, onBack, onConfirm, initialSettings }) {
  const [tab, setTab] = useState('settings');
  const brandColor = BRAND_COLORS[brand] || '#d4af37';
  const brandBg = BRAND_BGS[brand];
  const brandLogo = BRAND_LOGOS[brand];

  // Settings state
  const [budget, setBudget] = useState(initialSettings?.budget || 3000000);
  const [matchType, setMatchType] = useState(initialSettings?.matchType || 'classic');
  const [hofTrophies, setHofTrophies] = useState(initialSettings?.hofTrophies || 10);
  const [victoryCriteria, setVictoryCriteria] = useState(initialSettings?.victoryCriteria || 'fans');

  // Rivals state
  const [rivals, setRivals] = useState(initialSettings?.rivals || [null, null, null]);
  const [rivalPicker, setRivalPicker] = useState(null); // index

  const handleSaveRival = (index, data) => {
    setRivals(prev => prev.map((r, i) => i === index ? data : r));
  };

  const handleRemoveRival = (index) => {
    setRivals(prev => prev.map((r, i) => i === index ? null : r));
  };

  const handleConfirm = () => {
    onConfirm({ budget, matchType, hofTrophies, victoryCriteria, rivals: rivals.filter(Boolean) });
  };

  const formatBudget = (val) => val >= 1000000 ? `$${val / 1000000}M` : `$${val.toLocaleString()}`;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 40 }}>
      <style>{css}</style>
      <img loading="lazy" src={background} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
      {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.2, zIndex: 1 }} />}
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.88) 100%)', zIndex: 2 }} />

      {rivalPicker !== null && (
        <RivalPicker
          rival={rivals[rivalPicker]}
          onClose={() => setRivalPicker(null)}
          onSave={(data) => handleSaveRival(rivalPicker, data)}
        />
      )}

      <div style={{ position: 'absolute', inset: 0, zIndex: 6, display: 'flex', flexDirection: 'column', padding: '70px 28px 16px', gap: '14px', overflow: 'hidden' }}>

        {/* Title */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0 }}>
          {brandLogo && <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '44px', objectFit: 'contain', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.9))' }} />}
          <div style={{ ...S.title, fontSize: '1.4rem' }}>GAME SETTINGS</div>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.1)', flexShrink: 0 }}>
          {[{ key: 'settings', label: '⚙ SETTINGS' }, { key: 'rivals', label: '⚔ RIVALS' }].map(t => (
            <button key={t.key} className={`tab-btn${tab === t.key ? ' active' : ''}`}
              onClick={() => setTab(t.key)}
              style={{ ...S.mono, fontSize: '0.6rem', letterSpacing: '2px', background: 'transparent', border: 'none', borderBottom: '2px solid transparent', color: tab === t.key ? '#fff' : 'rgba(255,255,255,0.3)', padding: '10px 24px', cursor: 'pointer' }}>
              {t.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>

          {/* ── SETTINGS TAB ── */}
          {tab === 'settings' && (
            <div style={{ ...S.panel, flex: 1, overflow: 'auto', padding: '28px 32px', display: 'flex', flexDirection: 'column', gap: '32px' }}>

              {/* Budget */}
              <div>
                <label style={{ ...S.label, fontSize: '0.6rem' }}>BUDGET DE BASE</label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  {[3000000, 7000000].map(val => (
                    <OptionBtn key={val} label={formatBudget(val)}
                      description={val === 3000000 ? 'Mode difficile' : 'Mode confortable'}
                      selected={budget === val}
                      onClick={() => setBudget(val)} />
                  ))}
                </div>
              </div>

              <div style={{ height: '1px', background: 'rgba(255,255,255,0.06)' }} />

              {/* Match type */}
              <div>
                <label style={{ ...S.label, fontSize: '0.6rem' }}>TYPE DE MATCH</label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <OptionBtn label="CLASSIC"
                    description="Tous les types de match disponibles dès le début"
                    selected={matchType === 'classic'}
                    onClick={() => setMatchType('classic')} />
                  <OptionBtn label="TO UNLOCK"
                    description="Certains types de match à débloquer via la logistique"
                    selected={matchType === 'unlock'}
                    onClick={() => setMatchType('unlock')} />
                </div>
              </div>

              <div style={{ height: '1px', background: 'rgba(255,255,255,0.06)' }} />

              {/* HoF Trophies */}
              <div>
                <label style={{ ...S.label, fontSize: '0.6rem' }}>TROPHÉES HALL OF FAME</label>
                <div style={{ ...S.mono, fontSize: '0.48rem', color: 'rgba(255,255,255,0.3)', marginBottom: '12px', letterSpacing: '0.5px' }}>
                  La saison se termine quand ce nombre de trophées est atteint.
                </div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {HOF_OPTIONS.map(val => (
                    <OptionBtn key={val} label={`${val}`}
                      selected={hofTrophies === val}
                      onClick={() => setHofTrophies(val)} />
                  ))}
                </div>
              </div>

              <div style={{ height: '1px', background: 'rgba(255,255,255,0.06)' }} />

              {/* Victory criteria */}
              <div>
                <label style={{ ...S.label, fontSize: '0.6rem' }}>VICTORY CRITERIA</label>
                <div style={{ ...S.mono, fontSize: '0.48rem', color: 'rgba(255,255,255,0.3)', marginBottom: '12px', letterSpacing: '0.5px' }}>
                  Le classement et la victoire finale se basent sur ce critère.
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <OptionBtn label="FANS"
                    description="Rank based on fans numbers"
                    selected={victoryCriteria === 'fans'}
                    onClick={() => setVictoryCriteria('fans')} />
                  <OptionBtn label="HoF TROPHIES"
                    description="Rank based on HoF Trophies"
                    selected={victoryCriteria === 'hof'}
                    onClick={() => setVictoryCriteria('hof')} />
                </div>
              </div>
            </div>
          )}

          {/* ── RIVALS TAB ── */}
          {tab === 'rivals' && (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px', overflow: 'hidden' }}>
              <div style={{ ...S.mono, fontSize: '0.52rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '0.5px', flexShrink: 0 }}>
                Optionnel — Ajoutez jusqu'à 3 rivaux pour suivre leurs stats dans le Dashboard.
              </div>
              <div style={{ display: 'flex', gap: '14px', flex: 1, overflow: 'hidden' }}>
                {rivals.map((rival, i) => (
                  <RivalCard key={i} rival={rival} index={i}
                    onSet={() => setRivalPicker(i)}
                    onRemove={() => handleRemoveRival(i)} />
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ display: 'flex', justifyContent: 'space-between', flexShrink: 0 }}>
          <button className="btn-wwe" style={{ ...S.btn, color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.15)' }} onClick={onBack}>← BACK</button>
          <button className="btn-wwe" style={{ ...S.btn, borderColor: 'rgba(255,255,255,0.55)', color: '#fff', padding: '10px 40px', fontSize: '0.7rem', letterSpacing: '2px' }}
            onClick={handleConfirm}>
            CONFIRM →
          </button>
        </div>
      </div>
    </div>
  );
}
